import { render, staticRenderFns } from "./gc-popup-column-info.vue?vue&type=template&id=5fcb4722&scoped=true"
import script from "./gc-popup-column-info.vue?vue&type=script&lang=js"
export * from "./gc-popup-column-info.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-column-info.vue?vue&type=style&index=0&id=5fcb4722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcb4722",
  null
  
)

export default component.exports